import React from 'react';
import ITService from '../images/it.svg'
import SubServiceSectionIT from '../components/SubServiceSectionIT';
import { Link } from 'react-router-dom';


const ITServices = () => {
  return (
    <div className = "relative">
    <img
      className="h-auto w-full object-cover"
      src={ITService}
      alt="IT Services"
    />
    {/* <div className="absolute top-48 left-4 p-4 bg-opacity-75 bg-black text-white">
      <h1 className="text-2xl sm:text-4xl font-semibold">Marketing Services</h1>
    </div> */}

    <div>

    <section className='text-left mt-6'>
    <h1 className="text-center my-6 text-2xl font-semibold">IT Services</h1>
      {/* <h1 className="text-xl font-semibold m-6 text-[#13689b]">Our Managed IT Services ensure a smooth transition and ongoing optimization with a three-step process:</h1> */}
      <p className="text-md text-black px-12 text-justify">
      WhyMe Solutions offers advanced IT services to enhance your technology infrastructure and ensure smooth operations. Our skilled team provides customized solutions that cater to your specific IT needs, including but not limited to cybersecurity, web development and system management. In the digital era, having a solid IT infrastructure and services is essential for any business's efficiency, security, and growth and our team of specialists delivers customized solutions that utilize the latest technologies to optimize operations, enhance security, and drive digital transformation.
      </p>
      {/* <div className="border border-1 border-[#13689b] mt-4 mx-4"></div> */}
    </section>

    {/* <WeProvideSection /> */}
   

    <section>
      {/* <h2 className="text-xl font-semibold mb-6">Explore our Managed IT Services</h2>
      <p className="text-md text-gray-700 mb-6 px-12">
      Discover our range of Managed IT Services designed to keep your business running smoothly and efficiently. From immediate technical support to collaborative IT management and proactive network administration, our expert team is here to ensure your technology infrastructure is robust and reliable. Learn more about how our services can help you achieve your business goals.
      </p> */}
      
      <SubServiceSectionIT/>
      <div className='mb-6'>
      <h2 className="text-xl font-semibold mb-6 mx-6">Get Started with Expert IT Services</h2>
      <p className="text-md text-black mb-6 px-12 text-left">
      Maximize efficiency, enhance security, and drive growth with our tailored IT Services. Our certified experts provide 24/7 support, proactive monitoring, and strategic IT planning to meet your business needs.
      </p>
      
      <Link to="/contact"
        className="inline-block bg-[#13689b] text-white py-3 px-6 rounded-md text-md font-semibold transition-transform transform hover:scale-105">
      Contact Us
      </Link>
      </div>
    </section>

  </div>

  </div>
  )
}

export default ITServices
